export const BLOG_POST_QUERY = `
  query BlogPost($slug: String!, $locale: SiteLocale!) {
    blogPost(filter: { slug: { eq: $slug } }, locale: $locale) {
      id
      title
      authorName
      slug
      _locales
      _firstPublishedAt
      article
      featuredImage {
        responsiveImage(imgixParams: { w: 1200, h: 600, fit: crop }) {
          srcSet
          webpSrcSet
          sizes
          src
          alt
        }
      }
      seo {
        title
        description
        noIndex
        twitterCard
      }
    }
    morePosts: allBlogPosts(
      first: 2,
      filter: { slug: { neq: $slug } },
      locale: $locale,
      orderBy: _firstPublishedAt_DESC
    ) {
      id
      title
      slug
      _firstPublishedAt
      featuredImage {
        responsiveImage(imgixParams: { w: 600, h: 400, fit: crop }) {
          srcSet
          webpSrcSet
          sizes
          src
          alt
        }
      }
      seo {
        description
      }
    }
  }
`
